import Vue from 'vue'
import Router from 'vue-router'
import {getPathName} from '../../static/js/public'

const Confirm = () => import('@/pages/confirm')
const Login = () => import('@/pages/login')
const Privacy = () => import('@/pages/privacy')
const Faq = () => import('@/pages/faq')
const Selcountry = () => import('@/pages/selcountry')
const ServiceTerm = () => import('@/pages/serviceTerm')


let pathName = getPathName();
console.log("pathName---", pathName);

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: pathName + '/',
			name: 'Confirm',
			component: Confirm
		},
		{
			path: pathName + '/login',
			name: 'Login',
			component: Login
		},
		{
			path: pathName + 'login',
			redirect: pathName + '/login'
		},
		{
			path: pathName + '/privacy',
			name: 'Privacy',
			component: Privacy
		},
		{
			path: pathName + 'privacy',
			redirect: pathName + '/privacy'
		},
		{
			path: pathName + '/serviceTerm',
			name: 'ServiceTerm',
			component: ServiceTerm
		},
		{
			path: pathName + 'serviceTerm',
			redirect: pathName + '/serviceTerm'
		},
		{
			path: pathName + '/faq',
			name: 'Faq',
			component: Faq
		},
		{
			path: pathName + 'faq',
			redirect: pathName + '/faq'
		},
		{
			path: pathName + '/selcountry',
			name: 'Selcountry',
			component: Selcountry
		},
		{
			path: pathName + 'selcountry',
			redirect: pathName + '/selcountry'
		},
		{
			path: '*',
			redirect: pathName + '/'
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js